import React from 'react';
import { Link } from 'react-router-dom';

const ProfileCard = ({ 
  id, 
  name, 
  type, 
  picture,
  numberOfSessions = 0,
  averageLearningSessionTime = 0,
  averageAttentionPercentage = 0,
  summary = "No summary available yet"
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300">
      <div className="p-6">
        <div className="flex items-center space-x-4 mb-4">
          {picture ? (
            <img
              src={picture}
              alt={name}
              className="h-16 w-16 rounded-full object-cover"
            />
          ) : (
            <div className="h-16 w-16 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
              <span className="text-2xl font-bold text-white">
                {name.charAt(0).toUpperCase()}
              </span>
            </div>
          )}
          <div>
            <h3 className="text-xl font-bold text-gray-900">{name}</h3>
            <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
              type === 'PARENT'
                ? 'bg-blue-100 text-blue-800'
                : type === 'CHILD'
                ? 'bg-green-100 text-green-800'
                : 'bg-gray-100 text-gray-800'
            }`}>
              {type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()}
            </span>
          </div>
        </div>

        <div className="space-y-3 mb-4">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">Learning Sessions:</span>
            <span className="text-lg font-semibold text-gray-900">{numberOfSessions}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">Avg. Session Time:</span>
            <span className="text-lg font-semibold text-blue-600">{averageLearningSessionTime} min</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">Avg. Attention:</span>
            <span className="text-lg font-semibold text-green-600">{averageAttentionPercentage}%</span>
          </div>
        </div>

        {summary && summary !== "No summary available yet" && (
          <div className="mb-4">
            <p className="text-sm text-gray-600 line-clamp-3">{summary}</p>
          </div>
        )}
      </div>

      <div className="bg-gray-50 px-6 py-4">
        <Link
          to={`/chat/${id}`}
          className="block w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white text-center py-2 rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 font-medium"
        >
          Start Learning Session
        </Link>
      </div>
    </div>
  );
};

export default ProfileCard;

